module.exports = __webpack_public_path__ + "static/media/cat_typing.f783cdc9.gif";